import { lireJeton } from './enTetesAuth';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://apicabaza.creago.be/rest/cabaza';
// Clé d'API des lectures protégées.
//
// ELLE N'EST PAS SECRÈTE : toute variable `VITE_*` part en clair dans le bundle
// servi au navigateur. Elle écarte l'appel anonyme depuis l'extérieur, rien de
// plus — et ce qu'elle garde ici n'est que de la lecture publique.
//
// Pas de repli en dur : une clé absente doit se voir, pas se remplacer
// silencieusement par une valeur d'exemple que porte le dépôt.
const DEFAULT_API_KEY = import.meta.env.VITE_API_KEY;

function headers() {
    // LE JETON EN PLUS DE LA CLÉ, pas à sa place. La clé d'API écarte
    // l'appel anonyme mais ne dit pas QUI appelle — elle est identique pour
    // tout le monde et part en clair dans le bundle. Le jeton, lui, est
    // signé : c'est le seul élément qui atteste une identité, et les routes
    // d'écriture de help.cfc le réclament depuis le lot D.
    const jeton = lireJeton();

    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': DEFAULT_API_KEY,
        ...(jeton && { Authorization: `Bearer ${jeton}` })
    };
}

export const askQuestion = async ({ question, language = 'fr', userUuid = '' }) => {
    const res = await fetch(`${API_BASE_URL}/help/ask`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ question, language, userUuid })
    });
    const data = await res.json();
    if (!res.ok && !data.success && !data.SUCCESS) {
        throw new Error(data.message || `HTTP ${res.status}`);
    }
    return data.data || data.DATA || {};
};

export const rateAnswer = async (logUuid, rating) => {
    const res = await fetch(`${API_BASE_URL}/help/questions-log/${logUuid}/rate`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ rating })
    });
    return res.json();
};

export const getNudgeForEvent = async (event, userUuid = '', lang = 'fr') => {
    const qs = new URLSearchParams({ event, userUuid, lang });
    const res = await fetch(`${API_BASE_URL}/help/nudges/for-event?${qs.toString()}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    const payload = data.data || data.DATA || {};
    // API renvoie {nudge: ""} quand rien
    if (!payload || !payload.uuid) return null;
    return payload;
};

export const dismissNudge = async (uuid, userUuid, actionTaken = false) => {
    const res = await fetch(`${API_BASE_URL}/help/nudges/${uuid}/dismiss`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ userUuid, actionTaken })
    });
    return res.json();
};
